module.exports = __webpack_public_path__ + "static/media/logo_main2.5b46a3d8.png";